module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h3', [_vm._v("a simple solution for multicolor svg icon in Vue2.0")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "svg-icon-logo"
    }
  }, [_c('icon', {
    attrs: {
      "name": "chameleon",
      "scale": 35
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('section', [_c('h4', [_vm._v("simple usage")]), _vm._v(" "), _c('span', [_c('icon', {
    staticStyle: {
      "color": "#05CE7C"
    },
    attrs: {
      "name": "chameleon",
      "scale": "20"
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("spin")]), _vm._v(" "), _c('span', [_c('icon', {
    attrs: {
      "name": "sun",
      "scale": "20",
      "spin": ""
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("hover to change")]), _vm._v(" "), _c('span', [_c('icon', {
    attrs: {
      "name": "settings",
      "scale": "20",
      "id": "hover"
    }
  })]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("click to change")]), _vm._v(" "), _c('span', [_c('icon', {
    attrs: {
      "name": "unlock",
      "scale": "20",
      "id": "click"
    }
  })]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("animation")]), _vm._v(" "), _c('span', [_c('icon', {
    attrs: {
      "name": "chameleon",
      "scale": "20",
      "id": "animation"
    }
  })]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("advanced usage (tabbar)")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "advanced"
    }
  }, [_c('div', [_c('div', [_c('icon', {
    attrs: {
      "name": "roboAd",
      "scale": "12",
      "index": "0",
      "currentIndex": _vm.current
    },
    nativeOn: {
      "click": function($event) {
        _vm.switchTo(0)
      }
    }
  }), _vm._v(" "), _c('div', [_vm._v("btn1")])]), _vm._v(" "), _c('div', [_c('icon', {
    attrs: {
      "name": "pie",
      "scale": "12",
      "index": "1",
      "currentIndex": _vm.current
    },
    nativeOn: {
      "click": function($event) {
        _vm.switchTo(1)
      }
    }
  }), _vm._v(" "), _c('div', [_vm._v("btn2")])]), _vm._v(" "), _c('div', [_c('icon', {
    attrs: {
      "name": "cup",
      "scale": "12",
      "index": "2",
      "currentIndex": _vm.current
    },
    nativeOn: {
      "click": function($event) {
        _vm.switchTo(2)
      }
    }
  }), _vm._v(" "), _c('div', [_vm._v("btn3")])]), _vm._v(" "), _c('div', [_c('icon', {
    attrs: {
      "name": "settings2",
      "scale": "12",
      "index": "3",
      "currentIndex": _vm.current
    },
    nativeOn: {
      "click": function($event) {
        _vm.switchTo(3)
      }
    }
  }), _vm._v(" "), _c('div', [_vm._v("btn4")])])])]), _vm._v(" "), _vm._m(5)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('code', [_c('pre', [_c('strong', [_vm._v("html:")]), _vm._v("\n<icon "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"chameleon\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("scale")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"20\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"color: #05CE7C;\"")]), _vm._v("></icon>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('code', [_c('pre', [_c('strong', [_vm._v("html:")]), _vm._v("\n<icon "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"sun\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("scale")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"20\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("spin")]), _vm._v("></icon>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('code', [_c('pre', [_c('strong', [_vm._v("html:")]), _vm._v("\n<icon "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"settings\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("scale")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"20\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("id")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"hover\"")]), _vm._v("></icon>\n"), _c('strong', [_vm._v("css3:")]), _vm._v("\n#hover:hover {\n    "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("color")]), _vm._v(":"), _c('span', {
    staticClass: "val"
  }, [_vm._v("gold")]), _vm._v("\n}")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('code', [_c('pre', [_c('strong', [_vm._v("html:")]), _vm._v("\n<icon "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"unlock\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("scale")]), _vm._v("=\"20\" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("id")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"click\"")]), _vm._v("></icon>\n"), _c('strong', [_vm._v("css3:")]), _vm._v("\n#click:active {\n    "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("color")]), _vm._v(":"), _c('span', {
    staticClass: "val"
  }, [_vm._v("white")]), _vm._v("\n}")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('code', [_c('pre', [_c('strong', [_vm._v("html:")]), _vm._v("\n<icon "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"chameleon\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("scale")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"20\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("id")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"animation\"")]), _vm._v("></icon>\n"), _c('strong', [_vm._v("css3:")]), _vm._v("\n#animation {\n  "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("animation")]), _vm._v(": "), _c('span', {
    staticClass: "val"
  }, [_vm._v("changeColor 5s infinite step-end")]), _vm._v(";\n}\n@keyframes changeColor {\n  0% {\n      "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
    staticClass: "val"
  }, [_vm._v("red")]), _vm._v(";\n  }\n  20% {\n      "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
    staticClass: "val"
  }, [_vm._v("yellow")]), _vm._v(";\n  }\n  40% {\n      "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
    staticClass: "val"
  }, [_vm._v("blue")]), _vm._v(";\n  }\n  60% {\n      "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
    staticClass: "val"
  }, [_vm._v("green")]), _vm._v(";\n  }\n  80% {\n      "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
    staticClass: "val"
  }, [_vm._v("purple")]), _vm._v(";\n  }\n  100% {\n      "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
    staticClass: "val"
  }, [_vm._v("gold")]), _vm._v(";\n  }\n}")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('code', {
    attrs: {
      "id": "adCode"
    }
  }, [_c('pre', [_c('strong', [_vm._v("pseudocode:")]), _vm._v("\n"), _c('strong', [_vm._v("html:")]), _vm._v("\n<icon "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"roboAd\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("scale")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"12\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"0\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(":currentIndex")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"current\"")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    staticClass: "val"
  }, [_vm._v("\"switchTo(0)\"")]), _vm._v("></icon>\n<div>btn1</div>\n"), _c('strong', [_vm._v("css:")]), _vm._v("\n.active {\n  "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
    staticClass: "val"
  }, [_vm._v("gold")]), _vm._v(";\n}\nsvg {\n  "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
    staticClass: "val"
  }, [_vm._v("#fff")]), _vm._v(";\n  "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("padding")]), _vm._v(": "), _c('span', {
    staticClass: "val"
  }, [_vm._v("5px 0 2px")]), _vm._v(";\n}\n"), _c('strong', [_vm._v("js:")]), _vm._v("\ndata (){\n  return {\n    current: \"0\"\n  }\n},\nmethods: {\n  switchTo(index){\n    this.current = index.toString();\n  }\n}\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-63ecd18c!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 18
// module chunks = 1